module.exports = __webpack_public_path__ + "img/child-care.0e302608.png";